/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description nearMe reducers
 */

import { nullReducer, payloadReducer } from '@zcode/reducers'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import { RECEIVE_LISTABLES, RESET, SET_PROPERTY_TYPE } from '../constants/index'

const nearMeReducer = combineReducers({
  listables: handleActions(
    {
      [RECEIVE_LISTABLES]: payloadReducer,
      [RESET]: nullReducer,
    },
    null
  ),
  propertyType: handleActions(
    {
      [SET_PROPERTY_TYPE]: payloadReducer,
      [RESET]: nullReducer,
    },
    null
  ),
})

export default nearMeReducer
